'use strict';

module.exports = require('./lib/ReactDOMServer');



//////////////////
// WEBPACK FOOTER
// /~/react-dom/server.js
// module id = pqdH
// module chunks = 0